import React from "react";
import { ChevronDown, Facebook } from "lucide-react";
import { Button } from "./ui/button";

const FACEBOOK_URL =
  "https://www.facebook.com/people/Friends-of-Greg-Clark/61591538444437/";

const FLAG_IMG =
  "https://images.unsplash.com/photo-1562884328-39da45501a9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxhbWVyaWNhbiUyMGZsYWd8ZW58MHx8fHwxNzg0ODY0MzA2fDA&ixlib=rb-4.1.0&q=85&w=1800";

const Hero = () => {
  return (
    <section id="home" className="relative">
      <div className="relative h-[70vh] min-h-[520px] w-full overflow-hidden">
        <img
          src={FLAG_IMG}
          alt="American Flag"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a3161]/85 via-[#0a3161]/60 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

        <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-10 flex items-center">
          <div className="max-w-3xl fade-up">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur border border-white/25 text-white text-xs font-semibold tracking-[0.22em] uppercase mb-6">
              <span className="w-2 h-2 rounded-full bg-[#b22234]" />
              Oswego County Legislature
            </div>
            <h1 className="font-serif-display text-white text-6xl md:text-7xl lg:text-[104px] font-black leading-[0.92] tracking-tight drop-shadow-2xl">
              Gregory
              <br />
              Clark<span className="text-[#b22234]">.</span>
            </h1>
            <div className="mt-8 h-1.5 w-28 bg-[#b22234] rounded-full" />
            <p className="mt-8 font-serif-display text-white text-2xl md:text-3xl lg:text-[34px] font-semibold leading-[1.2] tracking-tight max-w-2xl">
              Candidate for the <span className="hero-underline">19th District</span> of Oswego County Legislature
            </p>
            <p className="mt-6 font-serif-display text-white text-2xl md:text-3xl lg:text-[34px] font-semibold leading-[1.2] tracking-tight max-w-2xl">
              Working for Oswego County&rsquo;s future. Together.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <a href="#about">
                <Button className="bg-white text-[#0a3161] hover:bg-slate-100 rounded-full h-12 px-8 text-[15px] font-semibold">
                  Meet Gregory
                </Button>
              </a>
              <a href="#donate">
                <Button className="bg-[#b22234] hover:bg-[#8f1a29] text-white rounded-full h-12 px-8 text-[15px] font-semibold">
                  Support the Campaign
                </Button>
              </a>
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">
                <Button className="bg-[#1877F2] hover:bg-[#0f5cbf] text-white rounded-full h-12 px-8 text-[15px] font-semibold">
                  <Facebook className="w-4 h-4 mr-2" />
                  Follow on Facebook
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-white/80 flex flex-col items-center gap-1 animate-bounce">
          <span className="text-[11px] uppercase tracking-[0.24em]">Scroll</span>
          <ChevronDown className="w-5 h-5" />
        </div>
      </div>

      <div className="divider-stripe" />
    </section>
  );
};

export default Hero;
